<template>
	<nut-dialog
		teleport="body"
		title="更换设备名称"
		:visible="modelValue"
		@ok="handleOK"
		@cancel="handleClose"
	>
		<nut-input class="input" placeholder="请输入设备名称" v-model="val" />
	</nut-dialog>
</template>

<script>
import { ref } from 'vue';
import { settingApi } from '@/apis';
import { Toast } from '@nutui/nutui';
export default {
	name: 'ChangeDeviceNameModal',
	props: {
		type: {
			required: true,
		},
		modelValue: {
			type: Boolean,
			required: true,
		},
		name: {
			type: String,
		},
	},
	emits: ['update:modelValue', 'success'],
	setup(props, { emit }) {
		const val = ref(props.name);
		const handleClose = () => {
			emit('update:modelValue', false);
		};
		const handleOK = async () => {
			await settingApi.setting_edit({
				type: 'name',
				value: val.value,
			});
			Toast.success('修改成功');
			emit('success', val.value);
			handleClose();
		};
		return {
			val,
			handleClose,
			handleOK,
		};
	},
};
</script>

<style lang="scss" scoped>
.input {
	padding: 8px 0;
	font-size: $small-font-size;
}
</style>
